/* eslint no-use-before-define: ["error", { "variables": false }] */

import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  UIManager,
  View,
  Keyboard,
  Animated,
  Platform,
} from "react-native";

import Composer from "./Composer";
import Send from "./Send";
import Color from "@microdoing/shared/constants/Colors";
import Colors from "@microdoing/shared/constants/Colors";

const MIN_COMPOSER_HEIGHT = Platform.select({
  ios: 33,
  android: 41,
});
export const MAX_COMPOSER_HEIGHT = 200;
export const DEFAULT_PLACEHOLDER = "Type a message...";
export const DATE_FORMAT = "ll";
export const TIME_FORMAT = "LT";

class InputBar extends React.Component {
  constructor(props) {
    super(props);

    this.keyboardWillShow = this.keyboardWillShow.bind(this);
    this.keyboardWillHide = this.keyboardWillHide.bind(this);
    this.keyboardWillShowListener = Keyboard.addListener(
      "keyboardWillShow",
      this.keyboardWillShow,
    );
    this.keyboardWillHideListener = Keyboard.addListener(
      "keyboardWillHide",
      this.keyboardWillHide,
    );

    this.state = {
      position: "absolute",
      shift: new Animated.Value(0),
    };
  }

  // componentWillMount() {
  //   this.keyboardWillShowListener = Keyboard.addListener(
  //     "keyboardWillShow",
  //     this.keyboardWillShow
  //   );
  //   this.keyboardWillHideListener = Keyboard.addListener(
  //     "keyboardWillHide",
  //     this.keyboardWillHide
  //   );
  // }

  componentWillUnmount() {
    this.keyboardWillShowListener.remove();
    this.keyboardWillHideListener.remove();
  }

  keyboardWillShow(event) {
    const keyboardHeight = event.endCoordinates.height;
    // if (this.state.position !== 'relative') {
    //   this.setState({
    //     position: 'relative'
    //   });
    // }

    Animated.timing(this.state.shift, {
      toValue: -keyboardHeight,
      duration: 400,
      useNativeDriver: true,
    }).start();
  }

  keyboardWillHide() {
    if (this.state.position !== "absolute") {
      this.setState({
        position: "absolute",
      });
    }
    Animated.timing(this.state.shift, {
      toValue: 0,
      duration: 400,
      useNativeDriver: true,
    }).start();
  }

  renderSend() {
    // if (this.props.renderSend) {
    //   return this.props.renderSend(this.props);
    // }
    return <Send {...this.props} />;
  }

  renderComposer() {
    // if (this.props.renderComposer) {
    //   return this.props.renderComposer(this.props);
    // }

    return <Composer {...this.props} />;
  }

  render() {
    return (
      <Animated.View
        style={[
          styles.container,
          this.props.containerStyle,
          {
            position: this.state.position,
            transform: [{ translateY: this.state.shift }],
          },
        ]}
      >
        <View style={[styles.primary, this.props.primaryStyle]}>
          {this.renderComposer()}
          {this.renderSend()}
        </View>
      </Animated.View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    // borderTopWidth: StyleSheet.hairlineWidth,
    // borderTopColor: Color.defaultColor,
    backgroundColor: "transparent",
    paddingBottom: 7,
    paddingTop: 7,
    paddingLeft: 10,
    paddingRight: 10,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  primary: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  accessory: {
    height: 44,
  },
});

InputBar.defaultProps = {
  hideInput: false,
  renderAccessory: null,
  renderActions: null,
  renderSend: null,
  renderComposer: null,
  containerStyle: {},
  primaryStyle: {},
  accessoryStyle: {},
  onPressActionButton: () => {},
};

export { InputBar };
